import { grey } from '@mui/material/colors';

export default {
  paper: {
    backgroundColor: grey['100']
  }
};
